import { Controller } from '@hotwired/stimulus'
import { Datepicker } from 'flowbite'
import { Datepicker as InternalDatepicker } from 'flowbite-datepicker'
import it from '../../../node_modules/flowbite-datepicker/dist/js/locales/it.js'

InternalDatepicker.locales.it = it.it

// Wires a text field to flowbite-datepicker (Italian locale, dd/mm/yyyy) with a clear button.
export default class extends Controller {
  static targets = ['input', 'clear']

  connect() {
    this.picker = new Datepicker(this.inputTarget, {
      autohide: true,
      format: 'dd/mm/yyyy',
      language: this.inputTarget.dataset.language || 'it',
      orientation: 'bottom'
    })

    this.inputTarget.addEventListener('changeDate', this.#toggleClear)
    this.#toggleClear()
  }

  disconnect() {
    this.picker?.destroy()
  }

  clear() {
    this.inputTarget.value = ''
    this.inputTarget.dispatchEvent(new Event('change'))
    this.#toggleClear()
  }

  #toggleClear = () => {
    if (!this.hasClearTarget) { return }

    this.clearTarget.classList.toggle('hidden', !this.inputTarget.value)
  }
}
